import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom'

export default function ResetPassword() {
    const imageUrl = "./assets/images/";
    const { register, handleSubmit, reset, formState: { errors },
    } = useForm();
    const navigate = useNavigate()
    // show hide password
    const [password, showPassword] = useState(false);
    const showpassword = () => showPassword(!password);
    // login api
    const loginUser = async (data) => {
        navigate("/");
    };
    return (
        <div className="login-form">
            <div className="text-center mb-8">
                <h1 className='heading-color Sora_SB text-3xl mb-2'>Reset Password</h1>
                <p className='Sora_R opacity-80  text-sm'>Please enter your new password</p>
            </div>
            <form onSubmit={handleSubmit(loginUser)}>
                <div class="mb-8">
                    <label class="block text-sm mb-2" for="password">
                        New Password
                    </label>
                    <div className="flex input-box">
                        <input class="appearance-none w-full focus:outline-none focus:shadow-outline" id="password"
                            type={password ? "text" : "password"} placeholder="Enter password"  {...register("password", { required: true })} />
                        <img src={password ? imageUrl + "eye-hide.svg" : imageUrl + "eye.svg"} alt="" onClick={showpassword} className='pointer' />
                    </div>
                    {errors.password && <span className="text-red-500 text-xs italic">This field is required</span>}
                </div>
                <div class="mb-8">
                    <label class="block text-sm mb-2" for="password">
                        Confirm Password
                    </label>
                    <div className="flex input-box">
                        <input class="appearance-none w-full focus:outline-none focus:shadow-outline" id="password"
                            type={password ? "text" : "password"} placeholder="Enter password"  {...register("password", { required: true })} />
                        <img src={password ? imageUrl + "eye-hide.svg" : imageUrl + "eye.svg"} alt="" onClick={showpassword} className='pointer' />
                    </div>
                    {errors.password && <span className="text-red-500 text-xs italic">This field is required</span>}
                </div>
                <div class="flex items-center justify-between">
                    <button type="submit" class="btn w-full text-center">
                        Submit
                    </button>
                </div>
            </form>
        </div >
    )
}
